import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from "@mui/styles";
import styles from './buttonWithToolTip.module.scss';
import Button from '../Button';
import SVG from 'react-inlinesvg';

const StyledToolTip = withStyles(() => ({
    tooltip: {
      backgroundColor: '#EAEBF0',
      color: '#6F7984',
      fontSize: 11,
      borderRadius: '8px',
    },
  }))(Tooltip);

 export const ButtonWithToolTip = ({ icon, onClick, className, placement, title='', loading, disabled, label, flexStart, iconButton=false }) => {
    return(
      <StyledToolTip placement={placement} title={title}>
        <div className={flexStart? styles.flexStart : styles.butonContainer}>
          <Button
            iconButton={iconButton}
            onClick={onClick}
            className={`${styles.filterButton} ${className}`}
            loading={loading}
            disabled={disabled}
            label={label}
            flexStart={flexStart}
          >
            {
              label?
              <div className={styles.buttonContent}>
                <SVG src={icon} title="" alt="" />
                <span>{label}</span>
              </div>
              :
              <SVG src={icon} title="" alt="" />
            }
          </Button>
        </div>
      </StyledToolTip>
    )
  }

export default ButtonWithToolTip;